import { Component, OnInit,Input } from '@angular/core';
import { CleanerService } from '../../../../injections/cleaner.service';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';

@Component({
    selector: 'cleaner-comments',
    templateUrl: '../../templates/partials/comments-cleaner.html'
})

export class CleanerCommentsComponent implements OnInit {

    @Input() comments;
    public showCommentBox: boolean = false;
    public insertComment;
    public idCleaner;

    constructor(private cleanerService: CleanerService, private route: ActivatedRoute) { 
        this.route.params.subscribe(params => {
            this.idCleaner = params["id"];
          });
    }

    public showAddComment(type: string) {
        this.showCommentBox = (type == "show") ? true : false;
    }

    public addComment() {
        var dataComment = {
            text: this.insertComment,
            id_manager_user: 1,
            type: ""
        };
        this.insertComment = null;
        this.cleanerService.createCleanerComment(this.idCleaner,dataComment).subscribe(response => {
            dataComment["id_professional_comment"] = response["response"]["insertId"];
            dataComment["id_professional"] = this.idCleaner;
            dataComment["date"] = moment().format("DD/MM/YYYY HH:mm");;
            this.comments.unshift(dataComment);
            this.showAddComment('hide');
        });
    }

    public updateComment(event: any) {
        //console.log(event);
        if(event["action"] == "update"){
            let data = {
                text: event["data"]["text"]
            }
            this.cleanerService.updateCleanerComment(this.idCleaner,event["data"]["id_professional_comment"], data).subscribe(result => {
                //console.log(result);
            });
        }else{
            this.cleanerService.deleteCleanerComment(this.idCleaner,event["data"]["id_professional_comment"]).subscribe(result => {
                //console.log(event["index"]);
                if(result["status"] == "OK") this.comments.splice(event["index"], 1);
            });
        }
    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/modules/cleaners/components/dummy/comments-cleaner.component.ts